export default __webpack_public_path__ + "static/media/studio_contest_3_ko.2051969f.jpg";